import { Pipe, PipeTransform } from '@angular/core';
import { EmployeeDTO } from "../../domain/user/employee/dto/EmployeeDTO";
import { EMPLOYEE_ROLE_DISPLAY_MAP } from '../../domain/user/employee/dto/role-type';

@Pipe({
  name: 'employeeRoleDisplay',
  standalone: true,
})
export class EmployeeRoleDisplayPipe implements PipeTransform {

  transform(employee: EmployeeDTO): string {
    if (employee.isOrganizationAdmin) {
      return 'Owner';
    }

    return EMPLOYEE_ROLE_DISPLAY_MAP.get(employee.role) || 'User';
  }
}
